import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';

export const getNotifications = async (token: string) => {
  let res = await apiManager.patch("/admin/fcm", { fcm: token });
  return res;
};


export const useGetNotifications = () =>
  useMutation({
    mutationFn: async (fcmToken: string) => {
      const res = await apiClient.patch("/admin/fcm", { fcm: fcmToken });
      return res.data;
    },
    onError: () => {
    },
  });